import { useEffect, useState } from "react";
import { Custom } from "components";
import { useApp } from "contexts";

export type LoginType = {
  email: string;
  password: string;
};

type Props = {
  current: LoginType;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  disabledEmail?: boolean;
};

export const Fields = ({ current, onChange, onBlur, disabledEmail }: Props) => {
  const { t } = useApp();

  return (
    <>
      <Custom.TextField
        type="email"
        name="email"
        required
        disabled={disabledEmail}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={t.placeholder.email_address}
        value={current.email}
        label={t.label.email}
      />
      <Custom.TextField
        type="password"
        name="password"
        required
        onChange={onChange}
        onBlur={onBlur}
        placeholder={t.placeholder.password}
        value={current.password}
        label={t.label.password}
      />
    </>
  );
};
